export default {
    practiceTitle:"Centre d'entraînement",
    practiceDescription:"Perfectionnez vos compétences linguistiques grâce à des exercices ciblés",
    practiceTestLabel:"Tests d'entraînement",
    progressLabel:"Progression",

}
